<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-row v-else>
            <b-col md="6">
                <b-card>
                    <template v-slot:header>
                        <h5>Detail Banner Mobile</h5>
                    </template>
                    <div class="font-weight-bold">Judul</div>
                    <div>{{ dtl.judul }}</div>
                    <div class="font-weight-bold mt-3">Dibuat pada</div>
                    <div>{{ $helper.changeDateFormat(dtl.createdAt) }}, {{ $helper.changeDateFormatGetHour(dtl.createdAt) }}</div>
                    <div class="font-weight-bold mt-3">Status</div>
                    <div v-if="dtl.urutan == null" class="text-muted">Tidak aktif</div>
                    <div v-else>Aktif - Urutan #{{ dtl.urutan }}</div>
                    <div class="font-weight-bold mt-3">Teks</div>
                    <span style="white-space: pre-line">{{ dtl.teks }}</span>
                    <div class="font-weight-bold mt-3">Tautan / Link Tambahan</div>
                    <div v-if="dtl.link == null" class="text-muted">Tidak ada</div>
                    <div v-else>{{ dtl.link || "-" }}</div>
                    <div class="font-weight-bold mt-3">Foto Banner</div>
                    <img :src="$baseFilePath + dtl.photo" style="max-width:100%" />
                    <div class="text-right mt-4">
                        <router-link :to="'/master/banner-mobile/' + $route.params.id + '/edit'">
                            <b-button variant="warning">
                                <i class="fa fa-pencil mr-2" /> Edit
                            </b-button>
                        </router-link>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'banner-mobile-detail',
    data() {
        return {

            initStatus: 0,
            dtl: {}

        }
    },
    methods: {

        init() {

            this.initStatus = 0

            let getDetail = this.$axios.get("banner-mobile/" + this.$route.params.id).then(res => {
                this.dtl = res.data
            })

            Promise.all([getDetail]).then(res => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        }

    },
    created() {

        this.init()

        let flash = this.$helper.getFlash()
        if(flash != null) {
            this.$helper.toastSucc(this, flash)
        }

    }
}
</script>